import {
  Box,
  Button,
  Input,
  Text,
  useToast,
  VStack,
  Badge,
} from "@chakra-ui/react";
import axios from "axios";
import * as React from "react";
import Papa from "papaparse";
import { api } from "../../config";

interface CSVRow {
  "Codice ID": string;
  Password: string;
}

const BlockStudents: React.FC = () => {
  const [file, setFile] = React.useState<File | null>(null);
  const [rows, setRows] = React.useState<CSVRow[]>([]);
  const [loading, setLoading] = React.useState(false);
  const toast = useToast();

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = e.target.files?.[0];
    if (!selected) return;

    setFile(selected);

    Papa.parse(selected, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        setRows(results.data as CSVRow[]);
      },
    });
  };

  const handleUpload = async () => {
    try {
      if (!rows.length) throw new Error("CSV is empty");

      const confirm = window.confirm(
        `Block ${rows.length} students and reset passwords?`
      );
      if (!confirm) return;

      setLoading(true);

      const res = await axios.post(
        `${api}/blocks/block-from-csv`,
        { users: rows },
        { withCredentials: true }
      );

      toast({
        title: `✅ ${res.data.updatedCount} students blocked`,
        status: "success",
        position: "bottom-right",
      });

    } catch (err: any) {
      toast({
        title: err.message || "Upload failed",
        status: "error",
        position: "bottom-right",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box p="8" maxW="500px">
      <Text fontSize="2xl" mb="4" fontWeight="bold">
        🚫 Block Students via CSV
      </Text>

      <VStack spacing={4} align="stretch">
        <Input type="file" accept=".csv" onChange={handleFileChange} />

        {file && (
          <Box>
            <Text fontSize="sm">
              File: <b>{file.name}</b>
            </Text>
            <Badge colorScheme="blue" mt="2">
              {rows.length} records found
            </Badge>
          </Box>
        )}

        <Button
          colorScheme="red"
          onClick={handleUpload}
          isLoading={loading}
          isDisabled={!rows.length}
        >
          Upload & Block Students
        </Button>
      </VStack>
    </Box>
  );
};

export default BlockStudents;